import { UserDataResp } from 'config/types/Authentication'
import { useSelector } from 'react-redux'
import { AppState } from 'state'

export const useUserData = (): UserDataResp => {
  return useSelector<AppState, AppState['user']['userData']>((state) => state.user.userData)
}
